<mat-card>
  <mat-card-content>

    <div class="mb-4">
      <!-- canh bao -->
      <div class="row" style="padding-right: 0.75rem; justify-content: flex-end" *ngIf="isShowWarningExpireContractQuantity ||
                   isContractQuantityExpired ||
                   isShowWarningExpireDigContract ||
                   isStorageDigContractExpired ||
                   (me && me.isWarning)
                   ">
        <!-- Cảnh báo gộp  -->
        <div class="col-md-12 pr-0 notify-card"
             *ngIf="(isShowWarningExpireContractQuantity && !isContractQuantityExpired && isShowWarningExpireDigContract) || (isShowWarningExpireContractQuantity && isStorageDigContractExpired) || (isContractQuantityExpired && isShowWarningExpireDigContract) || (isContractQuantityExpired && isStorageDigContractExpired) ">
          <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
            <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
              <div class="d-flex">
                <div style="padding-right: 10px;">
                  <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
                </div>
                <div class="flex-grow-3" style="margin: 0 auto;text-align: center;">
                  <span *ngIf="isContractQuantityExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' |
                    translate}}</span>
                  <span *ngIf="!isContractQuantityExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expire1' |
                    translate}}{{ContractQuantityExpireTitle}}{{'analysis.analysis_report_enterprise.notify_contract_quantity_expire2'
                    | translate}}</span>
                  <br><span *ngIf="isStorageDigContractExpired" class="font15"
                            style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' |
                  translate}}</span>
                  <span *ngIf="!isStorageDigContractExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire1' |
                    translate}}{{storageDigContractExpireTitle}}{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire2'
                    | translate}}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Cảnh báo hết hạn hợp đồng -->
        <div class="col-md-12 pr-0 notify-card"
             *ngIf="!((isShowWarningExpireContractQuantity && isShowWarningExpireDigContract) || (isShowWarningExpireContractQuantity && isStorageDigContractExpired) || (isContractQuantityExpired && isShowWarningExpireDigContract) || (isContractQuantityExpired && isStorageDigContractExpired)) && (isShowWarningExpireContractQuantity || isContractQuantityExpired)">
          <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
            <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
              <div class="d-flex">
                <div style="padding-right: 10px;">
                  <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
                </div>
                <div class="flex-grow-3" style="margin: 0 auto;text-align: center;">
                  <span *ngIf="isContractQuantityExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expired' |
                    translate}}</span>
                  <span *ngIf="!isContractQuantityExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_contract_quantity_expire1' |
                    translate}}{{ContractQuantityExpireTitle}}{{'analysis.analysis_report_enterprise.notify_contract_quantity_expire2'
                    | translate}}</span>

                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Cảnh báo hết hạn số hóa hợp đồng -->
        <div class="col-md-12 pr-0 notify-card"
             *ngIf="!((isShowWarningExpireContractQuantity && isShowWarningExpireDigContract) || (isShowWarningExpireContractQuantity && isStorageDigContractExpired) || (isContractQuantityExpired && isShowWarningExpireDigContract) || (isContractQuantityExpired && isStorageDigContractExpired)) && (isShowWarningExpireDigContract || isStorageDigContractExpired)">
          <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
            <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
              <div class="d-flex">
                <div style="padding-right: 10px;">
                  <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
                </div>
                <div class="flex-grow-3" style="margin: 0 auto;text-align: center;">
                  <span *ngIf="isStorageDigContractExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expired' |
                    translate}}</span>
                  <span *ngIf="!isStorageDigContractExpired" class="font15"
                        style="color: red;">{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire1' |
                    translate}}{{storageDigContractExpireTitle}}{{'analysis.analysis_report_enterprise.notify_storage_dig_contract_expire2'
                    | translate}}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- canh bao password -->
        <div class="col-md-12 pr-0 notify-card" *ngIf="me && me.isWarning">
          <div class="card boxshadow-card" style="border-radius: 15px; margin-bottom: 10px;">
            <div class="card-header font-weight-bold text-primary" style="background: #fbca69;border-radius: 14px;">
              <div class="d-flex">
                <div style="padding-right: 10px;">
                  <i class="fa fa-exclamation-circle fa-2x" style="color: red;" aria-hidden="true"></i>
                </div>
                <div class="flex-grow-3 pl-2">
                  <span>{{me.messagePasswordExpired}}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!--Hợp đồng chờ người dùng xử lý-->
        <div id="user-handle" class="col-12 mb-4 pr-075">
          <div class="card boxshadow-card">
            <div class="card-header font-weight-bold font16">
              {{'analysis.title.waiting_mine' | translate}}
            </div>
            <div class="card-body">
              <ng-container *ngIf="chartOptionsUserHandle">
                <highcharts-chart id="chartOptionsUserHandle" [Highcharts]="highcharts"
                                  [options]="chartOptionsUserHandle"
                                  style="width: 100%; height: auto; display: block;">
                </highcharts-chart>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="col-12 pr-075">
          <div class="bg-white p-3">
            <!--  time to use  -->
            <div class="d-flex justify-content-between align-items-center">
              <div class="title-time">{{'analysis.title.time_to_use' | translate}}</div>
              <div class="d-flex">
                <!--  CBB  -->
                <div>
                  <!-- ngày/tuần/tháng -->
                  <mat-form-field class="mr-2 border-none p-none" style="width: 70px; font-size: 16px">
                    <mat-select id="op" name="op" [(ngModel)]="optionsSelect"
                                (selectionChange)="onChangeSelect($event.value)">
                      <mat-option [value]="1">{{'analysis.analysis_report_consumption.options.day' | translate}}
                      </mat-option>
                      <mat-option [value]="2">{{'analysis.analysis_report_consumption.options.week' | translate}}
                      </mat-option>
                      <mat-option [value]="3">{{'analysis.analysis_report_consumption.options.month' | translate}}
                      </mat-option>
                      <mat-option [value]="4">{{'analysis.analysis_report_consumption.options.quarter' | translate}}
                      </mat-option>
                      <mat-option [value]="5">{{'analysis.analysis_report_consumption.options.year' | translate}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <div class="d-flex flex-wrap align-items-baseline" [formGroup]="consumptionFormGroup">
                    <!-- Từ ngày -->
                    <span class="mr-1" style="font-size: 16px">
                  {{'analysis.analysis_report_consumption.options.from_date' | translate}}:</span>
                    <mat-form-field class="mat-select-consumption mr-3 border-none" style="width: 120px;">
                      <input #inputFromDate matInput [matDatepicker]="createdTimeFromReference"
                             formControlName="fromDate"
                             (dateChange)="changeDatePickerFromDate('change', $event)"
                             (keyup.enter)="keyupEnterSelected();"
                             autocomplete="off" maxlength="200" #pickerInputFromDate/>
                      <mat-datepicker-toggle matSuffix [for]="createdTimeFromReference">
                        <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                           [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                      </mat-datepicker-toggle>
                      <mat-datepicker #createdTimeFromReference></mat-datepicker>
                      <!-- error -->
                      <mat-error
                        *ngIf="consumptionFormGroup.get('fromDate').invalid && (consumptionFormGroup.get('fromDate').dirty || consumptionFormGroup.get('fromDate').touched)"
                        style="font-size: 12px !important;">
                    <span *ngIf="consumptionFormGroup.get('fromDate').invalid">
                      {{getErrorDateMessageRange(pickerInputFromDate.value)}}
                    </span>
                        <span *ngIf="getErrorDateMessageRange(pickerInputFromDate.value)==null">
                      {{'validation.empty_of_date_consumption' | translate}}
                    </span>
                      </mat-error>
                    </mat-form-field>

                    <!-- Đến ngày -->
                    <span class="mr-1" style="font-size: 16px">
                  {{'analysis.analysis_report_consumption.options.to_date' | translate}}:</span>
                    <mat-form-field class="mat-select-consumption border-none" style="width: 120px;">
                      <input #inputToDate matInput [matDatepicker]="createdTimeToReference" formControlName="toDate"
                             (dateChange)="changeDatePickerToDate('change', $event)"
                             (keyup.enter)="keyupEnterSelected();"
                             autocomplete="off" maxlength="200" #pickerInputToDate/>
                      <mat-datepicker-toggle matSuffix [for]="createdTimeToReference">
                        <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                           [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                      </mat-datepicker-toggle>
                      <mat-datepicker #createdTimeToReference></mat-datepicker>
                      <!-- error -->
                      <mat-error
                        *ngIf="consumptionFormGroup.get('toDate').invalid && (consumptionFormGroup.get('toDate').dirty || consumptionFormGroup.get('toDate').touched)"
                        style="font-size: 12px !important;">
                    <span *ngIf="consumptionFormGroup.get('toDate').invalid">
                      {{getErrorDateMessageRange(pickerInputToDate.value)}}
                    </span>
                        <span *ngIf="getErrorDateMessageRange(pickerInputToDate.value)==null">
                      {{'validation.empty_of_date_consumption' | translate}}
                    </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <!-- Thông báo lỗi khi chọn thời gian -->
                  <div *ngIf="isShowWarningConsumptionFromDate || isShowWarningConsumptionToDate"
                       style="text-align: right;">
                    <mat-error style="font-size: 12px !important;" [ngSwitch]="optionsSelect">
                  <span *ngSwitchCase="1">{{ 'search_form.limit_day_select_create_date' | translate
                    }}</span>
                      <span *ngSwitchCase="2">{{ 'search_form.limit_week_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="3">{{ 'search_form.limit_month_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="4">{{ 'search_form.limit_quarter_select_create_date' | translate
                        }}</span>
                      <span *ngSwitchCase="5">{{ 'search_form.limit_year_select_create_date' | translate
                        }}</span>
                    </mat-error>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Hợp đồng nhận từ đối tác -->
              <div id="partner-report" class="col-12"
                   style="padding-right: 0.75rem;">
                <div class="card boxshadow-card partner-main">
                  <div class="card-header font-weight-bold font16">
                    {{'analysis.title.partner' | translate}}</div>
                  <div class="card-body">
                    <div class="row flex-grow-1">

                      <div class="col-md-3 col-6 pr-sm-12 mb-3 mb-md-0"
                           [ngStyle]="{'padding-right': '0.75rem'}">
                        <div class="card card-body-content-custom cursor-pointer"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.WAIT_SETUP_FLOW)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-ff7840">
                                <ng-container *ngTemplateOutlet="iconWait"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #ff7840">{{documentEnterpriseReceive.waitSetSignFlow}}</div>
                              <div
                                class="card-contract__title">{{'analysis.analysis_report_partner.status.wait_setup_flow' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3 col-6 mb-3 mb-md-0" style="padding-right: 0.75rem;">
                        <div class="card card-body-content-custom cursor-pointer"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.PROCESSING)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-2f75D0">
                                <ng-container *ngTemplateOutlet="iconProcess"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div
                                class="card-contract__value cursor-pointer"
                                style="color: #2f75D0">{{documentEnterpriseReceive.processing}}</div>
                              <div
                                class="card-contract__title">{{'analysis.analysis_report_partner.status.processing' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3 col-6 pr-sm-12"
                           [ngStyle]="{'padding-right': '0.75rem'}">
                        <div class="card card-body-content-custom cursor-pointer"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.SIGNED)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-15b98c">
                                <ng-container *ngTemplateOutlet="iconResolve"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div class="card-contract__value cursor-pointer"
                                   style="color: #15b98c">{{documentEnterpriseReceive.signed}}</div>
                              <div
                                class="card-contract__title">{{'analysis.analysis_report_partner.status.signed' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3 col-6" style="padding-right: 0.75rem;">
                        <div class="card card-body-content-custom cursor-pointer"
                             (click)="onClickPageNavigationDetailItem(enumContractEnterpriseStatus.REJECTED)">
                          <div class="card-contract">
                            <div>
                              <div class="round-fa-calendar bg-ee0033">
                                <ng-container *ngTemplateOutlet="iconReject"></ng-container>
                              </div>
                            </div>
                            <div>
                              <div class="card-contract__value cursor-pointer"
                                   style="color: #ee0033">{{documentEnterpriseReceive.rejected}}</div>
                              <div
                                class="card-contract__title">{{'analysis.analysis_report_partner.status.refused' | translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #iconWait>
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5385_6703)">
      <path
        d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58332V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33332V8.99929H21.6667V23.0826Z"
        fill="white"/>
      <path
        d="M16.665 21.3249H9.33498C9.15107 21.3249 9.0018 21.1756 9.0018 20.9917C9.0018 20.8078 9.15107 20.6585 9.33498 20.6585H16.665C16.8489 20.6585 16.9982 20.8078 16.9982 20.9917C16.9982 21.1756 16.8489 21.3249 16.665 21.3249Z"
        fill="white"/>
      <path
        d="M15.9987 13.3284V11.9957H10.0014V13.3284C10.0014 14.6361 10.8933 15.5571 11.4318 15.9939C10.8933 16.4307 10.0014 17.3516 10.0014 18.6593V19.9921H11.001C11.001 19.9921 11.8576 17.993 13.0001 17.993C14.1425 17.993 14.9992 19.9921 14.9992 19.9921H15.9987V18.6593C15.9987 17.3516 15.1068 16.4307 14.5683 15.9939C15.1068 15.5571 15.9987 14.6361 15.9987 13.3284Z"
        fill="white"/>
      <path
        d="M16.665 11.3293H9.33498C9.15107 11.3293 9.0018 11.1801 9.0018 10.9961C9.0018 10.8122 9.15107 10.663 9.33498 10.663H16.665C16.8489 10.663 16.9982 10.8122 16.9982 10.9961C16.9982 11.1801 16.8489 11.3293 16.665 11.3293Z"
        fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_5385_6703">
        <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #iconProcess>
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5385_6937)">
      <path
        d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58333V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33333V8.99929H21.6667V23.0826Z"
        fill="white"/>
      <path d="M18.4477 15.1266H7.55234" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_5385_6937">
        <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #iconResolve>
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5385_7168)">
      <path
        d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58334V1.41595H5.41667V3.58262H2.16667V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33334V8.99929H21.6667V23.0826Z"
        fill="white"/>
      <g clip-path="url(#clip1_5385_7168)">
        <path
          d="M11.5 17.4176L9.76501 15.6826C9.57001 15.4876 9.25501 15.4876 9.06001 15.6826C8.86501 15.8776 8.86501 16.1926 9.06001 16.3876L11.15 18.4776C11.345 18.6726 11.66 18.6726 11.855 18.4776L17.145 13.1876C17.34 12.9926 17.34 12.6776 17.145 12.4826C16.95 12.2876 16.635 12.2876 16.44 12.4826L11.5 17.4176Z"
          fill="white"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5385_7168">
        <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
      </clipPath>
      <clipPath id="clip1_5385_7168">
        <rect width="12" height="12" fill="white" transform="translate(7 9.33264)"/>
      </clipPath>
    </defs>
  </svg>
</ng-template>

<ng-template #iconReject>
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5385_7400)">
      <path
        d="M23.8333 3.58262H20.5833V1.41595H18.4167V3.58262H7.58332V1.41595H5.41666V3.58262H2.16666V25.2493H23.8333V3.58262ZM21.6667 23.0826H4.33332V8.99929H21.6667V23.0826Z"
        fill="white"/>
      <path
        d="M17.3377 12.367L16.4177 11.447L12.7705 15.0942L9.12333 11.447L8.20337 12.367L11.8506 16.0142L8.20337 19.6614L9.12333 20.5814L12.7705 16.9341L16.4177 20.5814L17.3377 19.6614L13.6905 16.0142L17.3377 12.367Z"
        fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_5385_7400">
        <rect width="26" height="26" fill="white" transform="translate(0 0.332642)"/>
      </clipPath>
    </defs>
  </svg>
</ng-template>
